<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>Create correspondence</h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label class="col-md-2">Title *</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.title"
                      type="text"
                      placeholder="Enter title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Type*</label>
                  <div class="col-md-10">
                    <select v-model="entity.type" class="form-control">
                      <option
                        v-for="corrType in corrTypesList"
                        :key="corrType"
                        :value="corrType"
                      >
                        {{ formatCorrType(corrType) }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Date</label>
                  <div class="col-md-10">
                    <datepicker
                      v-model="entity.date"
                      format="yyyy-MM-dd"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Receivers</label>
                  <div class="col-md-10">
                    <multiselect-remote
                      v-model="entity.receivers"
                      :default-options="defaultOptions.people"
                      :search-function="personSearch"
                      label="title"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Receiver location</label>
                  <div class="col-md-10">
                    <select-remote
                      v-model="entity.receivers_location"
                      :default-options="defaultOptions.locations"
                      :search-function="locationSearch"
                      label="title"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Senders</label>
                  <div class="col-md-10">
                    <multiselect-remote
                      v-model="entity.senders"
                      :default-options="defaultOptions.people"
                      :search-function="personSearch"
                      label="title"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Sender location</label>
                  <div class="col-md-10">
                    <select-remote
                      v-model="entity.senders_location"
                      :default-options="defaultOptions.locations"
                      :search-function="locationSearch"
                      label="title"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Body</label>
                  <div class="col-md-10">
                    <ckeditor id="body" v-model="entity.body" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="summary" class="col-md-2">Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="summary" v-model="entity.summary" />
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Text</label>
                  <div class="col-md-10">
                    <ckeditor id="text" v-model="entity.text" />
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-12">
                    <div class="form-group row">
                      <label class="col-md-2 form-control-label">PDF</label>
                      <div class="col-md-10">
                        <dropzone
                          v-if="dropzoneOptions"
                          id="files-uploader"
                          ref="dropzone"
                          class="dropzone-noprogress"
                          :options="dropzoneOptions"
                          @vdropzone-removed-file="fileChanged"
                          @vdropzone-file-added="fileChanged"
                        />
                        <div v-else>Dropzone can't work without upload url.</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="published" class="col-md-2">Published</label>
                  <div class="col-md-10">
                    <input id="published" v-model="entity.published" type="checkbox">
                  </div>
                </div>

                <div class="form-group row">
                  <label for="featured" class="col-md-2">Featured Content</label>
                  <div class="col-md-10">
                    <select id="featured" v-model="entity.featured" class="form-control" name="featured">
                      <option v-for="(item, key) in $_featuredBlocksList" :key="item" :value="key">{{ item }}</option>
                    </select>
                  </div>
                </div>

                <div v-if="entity.featured" class="form-group row">
                  <label for="bio" class="col-md-2">Featured Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="featured_body" v-model="entity.featuredBody" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>SEO</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">Title</label>
                  <div class="col-md-10">
                    <input
                      id="seo_title"
                      v-model="entity.seo_title"
                      type="text"
                      placeholder="Enter SEO title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Description</label>
                  <div class="col-md-10">
                    <textarea id="seo_desc" v-model="entity.seo_description" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <referencer
        @changeRefs="$_changeRefs"
      />

      <terms
        @changeTerms="$_changeTerms"
      />

      <div class="card">
        <div class="card-header">
          <strong>Path Alias</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="path_alias" class="col-md-2">{{ $config.app_api.host }}</label>
                  <div class="col-md-10">
                    <input
                      id="path_alias"
                      v-model="entity.path_alias"
                      type="text"
                      placeholder="Enter path alias"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Correspondence has created successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.css';
import MultiselectRemote from '@/global/components/MultiselectRemote';
import SelectRemote from '@/global/components/SelectRemote';
import Referencer from '@/global/components/Referencer';
import Datepicker from '@/global/components/Datepicker';
import Terms from '@/global/components/TermsEditor';
import config from '../../../config';
// Mixins
import CreatePageMixin from '@/mixins/CreatePageMixin';
import DefaultOptionsRequests from '@/mixins/DefaultOptionsRequests';

export default {
  name: 'CorrespondenceNew',

  components: {
    'multiselect-remote': MultiselectRemote,
    'select-remote': SelectRemote,
    dropzone: Dropzone,
    referencer: Referencer,
    datepicker: Datepicker,
    terms: Terms,
  },

  mixins: [CreatePageMixin, DefaultOptionsRequests],

  data() {
    return {
      entity: {
        title: null,
        body: null,
        summary: null,
        text: null,
        date: null,
        type: null,
        receivers: [],
        senders: [],
        receivers_location: null,
        senders_location: null,
        pdf: null,
        seo_title: '',
        seo_description: '',
        path_alias: '',
        published: true,
        featured: 0,
        featuredBody: '',
      },
      dropzoneOptions: {
        url: '/',
        maxFiles: 1,
        maxFilesize: 100,
        addRemoveLinks: true,
        acceptedFiles: 'application/',
        autoProcessQueue: false,
        accept: (file, done) => {
          const filesArray = _.filter(this.$refs.dropzone.dropzone.files, item => item.status !== 'error');
          if (filesArray.length > 1) {
            done('You can upload 1 file maximum');
          }
        },
      },
    };
  },

  computed: {
    corrTypesList() {
      return this.$store.state.corrTypes.list;
    },
  },

  mounted() {
    this.$_getDefaultPeople();
    this.$_getDefaultLocations();
  },

  methods: {
    formatCorrType(type) {
      return type.replace(/_/g, ' ');
    },
    locationSearch: _.debounce((loading, search, vm, searchRequestId) => {
      const context = vm;
      vm.$apiHttp.get(`${vm.$config.app_api.prefix}locations?search_string=${escape(search)}`)
        .then((response) => {
          if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
          loading(false);
          const entities = response.data;
          delete entities.meta;
          context.options = Object.keys(entities).map(e => entities[e]);
        })
        .catch((error) => {
          loading(false);
          console.error(error);
        });
    }, 350),
    personSearch: _.debounce((loading, search, vm, searchRequestId) => {
      const context = vm;
      vm.$apiHttp.get(`${vm.$config.app_api.prefix}people?search_string=${escape(search)}`)
        .then((response) => {
          if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
          loading(false);
          const entities = response.data;
          delete entities.meta;
          context.options = Object.keys(entities).map(e => entities[e]);
        })
        .catch((error) => {
          loading(false);
          console.error(error);
        });
    }, 350),
    isEntityValid() {
      return this.$_validate([
        { name: 'Title', value: this.entity.title, type: 'required' },
        { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 },
        { name: 'Path Alias', value: this.entity.path_alias, type: 'path' },
        { name: 'Type', value: this.entity.title, type: 'required' },
      ]);
    },
    fileChanged() {
      const filesArray = _.filter(this.$refs.dropzone.dropzone.files, item => item.status !== 'error');
      [this.entity.pdf] = filesArray;
    },
    saveRequest() {
      const postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      if (this.entity.body) postFormData.append('body', this.entity.body);
      if (this.entity.text) postFormData.append('text', this.entity.text);
      if (this.entity.date) postFormData.append('date', this.entity.date);
      if (this.entity.type) postFormData.append('type', this.entity.type);
      if (this.entity.pdf) postFormData.append('chunkedFile', true);
      if (this.entity.receivers_location) postFormData.append('receiver_location', this.entity.receivers_location.id);
      if (this.entity.senders_location) postFormData.append('sender_location', this.entity.senders_location.id);
      if (this.entity.senders) {
        for (let i = 0; i < this.entity.senders.length; i += 1) {
          postFormData.append('senders[]', this.entity.senders[i].id);
        }
      }
      if (this.entity.receivers) {
        for (let i = 0; i < this.entity.receivers.length; i += 1) {
          postFormData.append('receivers[]', this.entity.receivers[i].id);
        }
      }
      if (this.entity.featured) postFormData.append('featured', _.toNumber(this.entity.featured));
      if (this.entity.featuredBody) postFormData.append('featured_body', this.entity.featuredBody);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}correspondence`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      const file = this.$refs.dropzone.dropzone.files[0];
      const { prefix, host } = this.$config.app_api;
      const token = JSON.parse(localStorage.getItem(config.tokenStorage.name));
      const { acceptedFiles } = this.dropzoneOptions;
      this.saveRequest().then((response) => {
        this.$_successSave();
        if (file) {
          this.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: response.data.id,
            files: [file],
            token,
            acceptedFiles,
            contentType: response.data.content_type,
          });
        }
        this.$parent.getSource();
        window.location.hash = `#/admin/content/correspondence/edit/${response.data.id}`;
      }).catch((error) => {
        this.$_errorSave(error);
        console.error('Error in create correspondence query', error);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// New.vue?2c17ea08